import { useState } from 'react';
import { hashPassword } from '../../utils/hashUtil';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/ICONO APP/policia logo.png';
import './Login.css';

import { login } from '../../services/authService';
import { useUser } from '../../userContext';

import PopupMensaje from '../../iu/popupMensaje/PopupMensaje';
const Login = () => {
    const [popupMensaje, setPopupMensaje] = useState('');
    const [popupKey, setPopupKey] = useState(0);
    const handlePopupClose = () => {
        setPopupMensaje('');
        setPopupKey((prevKey) => prevKey + 1);
    };

    const { iniciarSesion, setToken } = useUser();
    const navigate = useNavigate();
    const [correo, setCorreo] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!correo) {
            setPopupMensaje('Escribe tu correo');
            return; // detenemos aquí
        }
        if (!password) {
            setPopupMensaje('Escribe tu contraseña');
            return; // detenemos aquí
        }
        try {
            const hashedPassword = await hashPassword(password);
            const data = await login(correo, hashedPassword);
            if (!data.accessToken) {
                setPopupMensaje('Acceso denegado');
            } else {
                setToken(data.accessToken);
                const nombreCompleto = `${data.user.nombre} ${data.user.apellido1} ${data.user.apellido2}`;
                iniciarSesion(data.user.id, nombreCompleto, data.user.correo, data.user.telefono, data.user.modulos, data.user.rol);
                navigate('/inicio');
            }
        } catch (error) {
            setPopupMensaje('Usuario o contraseña incorrectos');
        }
    };

    const handleRegister = () => {
        navigate('/register');
    };
    const handleBorrar = () => {
        navigate('/eliminar-mis-datos');
    };
    return (
        <div className="main">
            <div className="login-card">
                <img className="login-logo" src={Logo} alt="logo" />
                <h2>Inicio de Sesión</h2>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="correo">Usuario</label>
                        <input
                            id="correo"
                            className='input-login'
                            type="text"
                            value={correo}
                            onChange={(e) => setCorreo(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <input
                            id="password"
                            className='input-login'
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <div className='show-password-container'>
                            <input
                                type="checkbox"
                                id="show-password"
                                checked={showPassword}
                                onChange={toggleShowPassword}
                            />
                            <label htmlFor="show-password">Mostrar contraseña</label>
                        </div>
                    </div>
                    <button className="boton-primario" type="submit">
                        Iniciar Sesión
                    </button>
                    <div className="register-link">
                        ¿No tienes cuenta? <div onClick={handleRegister}>Registrate</div>
                    </div>
                </form>
            </div>
            <div className="register-link">
                ¿Quieres borrar tus datos? <div onClick={handleBorrar}>Borrar</div>
            </div>

            {popupMensaje && (
                <PopupMensaje
                    key={popupKey}
                    mensaje={popupMensaje}
                    onClose={handlePopupClose}
                />
            )}
        </div>
    );
};

export default Login;
